import { render, staticRenderFns } from "./BrandEn.vue?vue&type=template&id=5cabc5c1&scoped=true&"
import script from "./BrandEn.vue?vue&type=script&lang=js&"
export * from "./BrandEn.vue?vue&type=script&lang=js&"
import style0 from "./BrandEn.vue?vue&type=style&index=0&id=5cabc5c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabc5c1",
  null
  
)

export default component.exports